module.exports = __webpack_public_path__ + "static/media/mobile-nav-lobby-active.a5e140d0.svg";